import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { useCaseStudyId } from "../../../../context/CaseStudyContext";
import ResponsiveTable from "./ResponsiveTabel";
import { motion } from "motion/react";
import { fadeInAnimation } from "../../../animation/motionAnimation";

const CaseStudyCard = ({
  title,
  matrial,
  wirediameter,
  machine,
  previuos,
  Improved,
  index,
  id,
}) => {
  const { caseStudyId, setCaseStudyId } = useCaseStudyId();
  const previuosProcess = previuos.split("\n");
  const ImprovedProcess = Improved.split("\n");
  const { ref, inView, entry } = useInView({
    threshold: 0.5,
  });

  useEffect(() => {
    if (inView) {
      setCaseStudyId(entry?.target?.id);
    }
  }, [inView]);

  return (
    <div className="my-4" ref={ref} id={id}>
      <div className="overflow-hidden">
        <motion.h2 {...fadeInAnimation} className="text-4xl font-semibold">
          {title}
        </motion.h2>
      </div>

      <ResponsiveTable
        Material={matrial}
        Wire={wirediameter}
        Machine={machine}
      />

      <h2 className="text-3xl font-semibold">Previous process</h2>
      <ul>
        {previuosProcess?.map((v, i) => (
          <li className="text-xl p-2 text-mute-grey" key={i}>
            {v}
          </li>
        ))}
      </ul>
      <h2 className="text-3xl font-semibold">Improved process</h2>
      <ul>
        {ImprovedProcess?.map((v, i) => (
          <li className="text-xl p-2 text-mute-grey" key={i}>
            {v}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CaseStudyCard;
